import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { NotificationType } from "../../types/notificationtype";

@Injectable({
    "providedIn": "root"
})

export class NotificationTypeService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private notificationBaseUrl = this.apiRoot + "api/notificationtypes";

    getNotificationsType(): Observable<NotificationType[]> {
        return withSpinner(this.http).get<NotificationType[]>(`${this.notificationBaseUrl}/notificationTypes`);
    }
}